module.exports = __webpack_public_path__ + "static/media/G1-3-Alessa-Chronis-cod23.59bbce70.png";